module.exports = __webpack_public_path__ + "img/ATIS.cf194926.png";